import { render } from "./IndividualMemberships.vue?vue&type=template&id=1533b2af&scoped=true"
const script = {}

import "./IndividualMemberships.vue?vue&type=style&index=0&id=1533b2af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1533b2af"]])

export default __exports__